import React, { useEffect, useRef, useState, } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Role_Creation.css';
import EditPopup from './EditPopup';
import { BASE_URL } from "../../constants";
import { Button, Container, OverlayTrigger, Tooltip, Card, Row, Col, Form, InputGroup } from 'react-bootstrap';

function Role_Creation() {

    const [userId, setUserId] = useState(1);
    const [editMode, setEditMode] = useState('N');
    const [roleName, setRoleName] = useState();
    const [roleId, setRoleId] = useState();
    const [status, setStatus] = useState();
    const [menuItems, setMenuItems] = useState([]);
    const [addMode, setAddMode] = useState(true);
    const [addChkBox, setAddChkBox] = useState([]);
    const [editChkBox, setEditChkBox] = useState([]);
    const [processChkBox, setProcessChkBox] = useState([]);
    const [noAccessChkBox, setNoAccessChkBox] = useState([]);
    const [showEditPopup, setShowEditPopup] = useState(false);
    const [color, setColor] = useState('');
    const [selectAllAdd, setSelectAllAdd] = useState(false);
    const [selectAllEdit, setSelectAllEdit] = useState(false);
    const [isEditEnabled, setIsEditEnabled] = useState(false);
    const [isSaveEnabled, setIsSaveEnabled] = useState(false);

    const getMenuItems = () => {
        axios.get(`${ BASE_URL }/api/get_menu_items`)
            .then(response => {
                setMenuItems(response.data);
            })
            .catch(error => console.error('Error fetching exchanges:', error));
    }

    const handleEditClick = () => {
        setShowEditPopup(true);
    };

    const handleCloseEditPopup = () => {
        setShowEditPopup(false);
    };

    const handleSelectAllAdd = () => {
        const newValue = !selectAllAdd;
        setSelectAllAdd(newValue);
        setAddChkBox(menuItems.map((_, index) => noAccessChkBox[index] ? false : newValue));
    };
    
    const handleSelectAllEdit = () => {
        const newValue = !selectAllEdit;
        setSelectAllEdit(newValue);
        setEditChkBox(menuItems.map((_, index) => noAccessChkBox[index] ? false : newValue));
    };


    const handleVoucharRowSelect = (master_data) => {
        const editableRole = master_data.result2[0].role_id < 21 ? false : true;
    
        setRoleId(master_data.result2[0].role_id);
        setRoleName(master_data.result2[0].role_name);
        setStatus(master_data.result2[0].role_status);
    
        const result1 = master_data.result1;
    
        setAddChkBox(result1.map(result => result.add_flag === 'Y'));
        setEditChkBox(result1.map(result => result.edit_flag === 'Y'));
        setProcessChkBox(result1.map(result => result.process_flag === 'Y'));
        setNoAccessChkBox(result1.map(result => result.no_access_flag === 'Y' || false));
    
        setMenuItems(result1);
        setEditMode('Y');
        setAddMode(true); // Disable inputs/buttons
        
        // Enable "Edit" button, disable "New"
        setIsEditEnabled(true);            // Disable all inputs/buttons except Edit

    
        setShowEditPopup(false);
    };
    
    

    const handleEnableEditClick = () => {
        setAddMode(false);           // Enable inputs
        setIsEditEnabled(false);     // Disable Edit button
        setIsSaveEnabled(true);      // Enable Save button
    };
    const handleFinalSave = async () => {

        if (!roleName) {
            alert('Please Enter Role Name.');
            return;
        }

        let menuItemsData = [];

        menuItemsData = menuItems.map((item, index) => {
            return {
                module_id: item.module_id,
                menu_item_id: item.menu_item_id,
                add: addChkBox[index] || false,
                edit: editChkBox[index] || false,
                process: processChkBox[index] || false,
                no_access: noAccessChkBox[index] || false,
            };
        });

        let deleteIndex = [];

        for (let i = 0; i < menuItems.length; i++) {
            if ((!addChkBox[i] || addChkBox[i] === false) && (!editChkBox[i] || editChkBox[i] === false)
                && (!processChkBox[i] || processChkBox[i] === false)) {
                deleteIndex.push(i);
            }
        }
        const len = deleteIndex.length;

        if (deleteIndex.length > 0) {
            for (let i = 0; i < len; i++) {
                // if (i === menuItems.length - 1){
                //     break;
                // }
                deleteIndex[i + 1] = deleteIndex[i + 1] - (i+1);
                menuItemsData.splice(deleteIndex[i], 1);
            }
        }
        
        const mainData = {
            roleName,
            roleId,
            status,
            menuItemsData,
            userId,
            editMode,
        };

        const data = {
            header: mainData
        };

        if (roleName && status) {
            const isConfirmed = window.confirm("Sure you want to save the record?");
            if (!isConfirmed) {
                return;
            }
            await axios.post(`${ BASE_URL }/api/save_role_master`, data)
                .then(response => {
                    alert('Role saved successfully! ' + response.data.message);  
                    setStatus('A');
                    setRoleId('');
                    setRoleName('');
                    setAddChkBox([]);
                    setEditChkBox([]);
                    setProcessChkBox([]);
                    setNoAccessChkBox([]);
                    setMenuItems([]);
                    setAddMode(true);
                    setEditMode('N');
                    setIsEditEnabled(false);
                    setIsSaveEnabled(false);
                })
                .catch(error => console.error('Error saving Activity Slab: ', error));
        }    
    }

    const handleAddRole = () => {
        setStatus('A');
        setRoleName('');
        setAddMode(false);
        setAddChkBox([]);
        setEditChkBox([]);
        setProcessChkBox([]);
        setMenuItems([]);
        setEditMode('N');
        setIsSaveEnabled(true); 
    }

    const handleClearRole = () => {

        const isConfirmed = window.confirm('Sure, do you want to clear?');
        if (!isConfirmed) {
            return;
        }

        setEditMode('N');
        setRoleName('');
        setRoleId('');
        setStatus('A');
        setAddMode(true);
        setAddChkBox([]);
        setEditChkBox([]);
        setProcessChkBox([]);
        setNoAccessChkBox([]);
        setMenuItems([]);
        setIsEditEnabled(false);
        setIsSaveEnabled(false);
    }

    const handleNoAccessChkBox = (index, e) => {
        const isChecked = e.target.checked;

        // Update the "No Access" state for the current row
        setNoAccessChkBox(prevState => {
            const updatedState = [...prevState];
            updatedState[index] = isChecked;
            return updatedState;
        });

        // If "No Access" is checked, uncheck and disable the other checkboxes
        if (isChecked) {
            setAddChkBox(prevState => {
                const updatedState = [...prevState];
                updatedState[index] = false;
                return updatedState;
            });

            setEditChkBox(prevState => {
                const updatedState = [...prevState];
                updatedState[index] = false;
                return updatedState;
            });

            setProcessChkBox(prevState => {
                const updatedState = [...prevState];
                updatedState[index] = false;
                return updatedState;
            });
        }
    }

    const handleCheckboxChange = (index, setState, value) => {
        setState(prevState => {
            const updatedState = [...prevState];
            updatedState[index] = value;
            return updatedState;
        });
    };

    return (


        // <Container fluid className="p-3">

        //     <Card className="p-4 shadow-sm">
        //     </Card>

        // </Container>

        // <div className="px-5 py-1" style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Container fluid className="p-3">
            <div className="card flex-grow-1 d-flex flex-column">
                
                <div className="card-body" style={{ flex: '0 0 auto' }}>
                    {/* Sharing Slab & Alias */}
                    <div className="row">

                        <div className="col-md-6 mb-3 d-flex">
                            <label htmlFor="roleName" className="form-label label-width">Role Name</label>
                            <input id="roleName" type="text" className="form-control size_input_cashbank" value={roleName} disabled={addMode}
                                onChange={(e) => { setRoleName(e.target.value) }} />
                        </div>

                        <div className="col-md-6 mb-3 d-flex">
                            <label htmlFor="status" className="form-label label-width">Status</label>
                            <select id="status" className="form-select size_input_cashbank" style={{ width: '380px' }} disabled={addMode}
                                name='status' value={status} onChange={(e) => setStatus(e.target.value)}>
                                <option value="A">Active</option>
                                <option value="I">Inactive</option>
                            </select>
                        </div>

                    </div>

                    {/* Date From & Date To */}

                    <div className="mt-4">
                        <div className="d-flex" style={{ float: 'right' }}>
                            <button className="btn btn-primary me-2" style={{ width: '100px' }} onClick={handleAddRole}
                                disabled={!addMode}>New</button>
                            <button className="btn btn-warning me-2" style={{ width: '100px' }} onClick={handleEnableEditClick}  disabled={!isEditEnabled}>   
                                Edit</button>
                            <button className="btn  btn-secondary me-2" onClick={handleClearRole} style={{ width: '150px' }}
                                disabled={!isSaveEnabled}>Clear</button>
                            <button className="btn btn-primary me-2" style={{ width: '100px' }} onClick={handleEditClick}
                                disabled={!addMode} onRowSelect={handleVoucharRowSelect}>Search</button>
                            {showEditPopup && <EditPopup onClose={handleCloseEditPopup} onRowSelect={handleVoucharRowSelect} />}
                            <button className="btn btn-success me-2" style={{ width: '150px' }} onClick={handleFinalSave}
                                disabled={addMode}>Save</button>
                        </div>
                        <div className="d-flex" style={{ float: 'left' }}>
                            <button className="btn btn-warning me-2" style={editMode === 'N' 
                                ? { width: '155px', float: 'right', display: 'block' } : { width: '155px', float: 'right', display: 'none' }} 
                                onClick={getMenuItems} disabled={addMode} >Show Menu Items</button>
                        </div>
                    </div>
                </div>

                {/* <div className='table-container'> */}
                    <table className="table mt-3 table-wrapper">
                    <thead className='table-primary' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                    <tr>
                        <th style={{ width: '120px' }}>Module Name</th>
                        <th style={{ width: '120px' }}>Menu Items</th>
                        <th style={{ width: '80px' }}>Type</th>

                        {/* Add Column Header */}
                        <th style={{ width: '120px', textAlign: 'center' }}>
                            <div style={{ fontWeight: 'bold' }}>Add</div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginTop: '4px',
                                fontSize: '12px',
                                lineHeight: '1'
                            }}>
                                <label style={{ margin: 0, padding: 0 }}>Select All</label>
                                <input
                                    type="checkbox"
                                    checked={selectAllAdd}
                                    onChange={handleSelectAllAdd}
                                    disabled={addMode}
                                    style={{ marginTop: '2px' }}
                                />
                            </div>
                        </th>

                        {/* Edit Column Header */}
                        <th style={{ width: '120px', textAlign: 'center' }}>
                            <div style={{ fontWeight: 'bold' }}>Edit</div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginTop: '4px',
                                fontSize: '12px',
                                lineHeight: '1'
                            }}>
                                <label style={{ margin: 0, padding: 0 }}>Select All</label>
                                <input
                                    type="checkbox"
                                    checked={selectAllEdit}
                                    onChange={handleSelectAllEdit}
                                    disabled={addMode}
                                    style={{ marginTop: '2px' }}
                                />
                            </div>
                        </th>

                        <th style={{ width: '100px', textAlign: 'center' }}>Process</th>
                        <th style={{ width: '100px', textAlign: 'center' }}>No Access</th>
                        <th hidden>module_id</th>
                        <th hidden>menu_item_id</th>
                    </tr>
                </thead>

                        <tbody>
                            {menuItems.map((result, index) => (
                                <tr key={index} style={{ cursor: 'pointer' }}>
                                    <td style={result.module_id % 2 === 0 ? { backgroundColor: 'lightgray' } : { backgroundColor: 'white' }}>
                                        {result.module_name}</td>
                                    <td style={result.module_id % 2 === 0 ? { backgroundColor: 'lightgray' } : { backgroundColor: 'white' }}>
                                        {result.menu_name}</td>
                                    <td style={result.module_id % 2 === 0 ? { backgroundColor: 'lightgray' } : { backgroundColor: 'white' }}>
                                        {result.menu_type}</td>
                                    <td style={result.module_id % 2 === 0 ? { backgroundColor: 'lightgray' } : { backgroundColor: 'white' }}>
                                        <input
                                            type="checkbox"
                                            checked={addChkBox[index] || false}
                                            onChange={(e) => handleCheckboxChange(index, setAddChkBox, e.target.checked)}
                                            disabled={addMode || noAccessChkBox[index]}// Disable if "No Access" is checked
                                        />
                                    </td>
                                    <td style={result.module_id%2===0? { backgroundColor: 'lightgray' }:{ backgroundColor: 'white' }}>
                                        <input
                                            type="checkbox"
                                            checked={editChkBox[index] || false}
                                            onChange={(e) => handleCheckboxChange(index, setEditChkBox, e.target.checked)}
                                            disabled={addMode || noAccessChkBox[index]}// Disable if "No Access" is checked
                                        />
                                    </td>
                                    <td style={result.module_id%2===0? { backgroundColor: 'lightgray' }:{ backgroundColor: 'white' }}>
                                        <input
                                            type="checkbox"
                                            checked={processChkBox[index] || false}
                                            onChange={(e) => handleCheckboxChange(index, setProcessChkBox, e.target.checked)}
                                            disabled={addMode || noAccessChkBox[index]} // Disable if "No Access" is checked
                                        />
                                    </td>
                                    <td style={result.module_id%2===0? { backgroundColor: 'lightgray' }:{ backgroundColor: 'white' }}>
                                        <input
                                            type="checkbox"
                                            checked={noAccessChkBox[index] || false}
                                            onChange={(e) => handleNoAccessChkBox(index, e)}
                                            disabled={addMode || noAccessChkBox[index]}
                                        />
                                    </td>
                                    <th hidden>{result.module_id}</th>
                                    <td hidden>{result.menu_item_id}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                {/* </div> */}
            </div>
            </Container>
        // </div>
    );
}

export default Role_Creation;
